<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import ACLStatus from "./ACLStatus.vue";
import Tooltip from "./ui/Tooltip.vue";
import type { ChildInfo } from "../shared/services/effectiveAclCardState";

const props = defineProps<{
  status: number;
  error?: string;
  expiredAfter?: string;
  clickToGrant: boolean;
  childInfo: ChildInfo | null;
  align?: "start" | "center" | "end";
  delegatedIps?: { IP: string; Status: number }[];
  grantTypeFixedIps?: boolean;
  currentAddress?: string;
}>();

const { t } = useI18n();

const parentGrantConfirmed = computed(() => props.status === 0 || props.status === 5);
</script>

<template>
  <div
    :class="{
      'items-start': align === 'start',
      'items-center': align === 'center',
      'items-end': !align || align === 'end',
    }"
    class="flex flex-col"
  >
    <ACLStatus
      :click-to-grant="clickToGrant"
      :error="error"
      :expired-after="expiredAfter"
      :status="status"
      :delegated-ips="delegatedIps"
      :grant-type-fixed-ips="grantTypeFixedIps"
      :current-address="currentAddress"
    />
    <div v-if="childInfo && !childInfo.isHealthy && !parentGrantConfirmed" class="mt-1 text-xs">
      <template v-if="childInfo.statusName === 'AgentOffline'">
        <span class="text-amber-600 dark:text-amber-400">{{ t("fields.acls.childAgentOffline") }}</span>
      </template>
      <template v-else-if="childInfo.statusName === 'Pending'">
        <span class="text-amber-600 dark:text-amber-400">{{ t("fields.acls.childPending") }}</span>
      </template>
      <template v-else-if="childInfo.statusCode === 1 || childInfo.statusCode === 10">
        <Tooltip
          :focusable="true"
          :text="childInfo.error ?? t('fields.acls.childError')"
          aria-label="Active grant error"
        >
          <span class="text-amber-600 dark:text-amber-400">{{ t("fields.acls.childError") }}</span>
        </Tooltip>
      </template>
    </div>
  </div>
</template>
